import React from "react";
import Button from "../../../../../components/Button";
import { Modal } from "../../../../../components/Modal";
import { connectModal } from "../../../../../hocs/Modal";
import Radio from "../../../../../components/Radio";
import {Data} from "./data";
import {
  Answers,
  AnswerItem,
  AnswerTitle,
  AnswerText,
  FormActions,
  QuestionItem,
  Block,
  QuestionNumber,
  QuestionText,
  QuestionsList
} from "../styles";

const ACVModal = connectModal('acv-modal')(
  ({
     handleHide
   }) => {
    return (
      <Modal
        title={"ACV-опросник"}
        onClose={handleHide}
        width={"700px"}
        footer={<FormActions><Button title={"Отправить"} btnStyle={'primary'}/></FormActions>}
        noContentPadding
        closeDataTip={"После закрытия ответы не сохрантся"}
      >
        <Answers onMargin>
          {
            Data.answers.map((item, index) => {
              return (
                <AnswerItem key={'answer' + index}>
                  <AnswerTitle>{item.title}</AnswerTitle>
                  <AnswerText>{item.text}</AnswerText>
                </AnswerItem>
              )
            })
          }
        </Answers>
        <QuestionsList>
          {
            Data.questions.map((item, index) => {
              const num = index + 1;
              return (
                <QuestionItem>
                  <Block gap={4}>
                    <QuestionNumber>{num}</QuestionNumber>
                    <QuestionText>{item.text}</QuestionText>
                  </Block>
                  <Block padding={"0 0 0 28px"} gap={16}>
                    <Radio checked={false} value={"A"} name={'question' + num} label={"A"} onChange={()=>{}}/>
                    <Radio checked={false} value={"B"} name={'question' + num} label={"B"} onChange={()=>{}}/>
                    <Radio checked={false} value={"C"} name={'question' + num} label={"C"} onChange={()=>{}}/>
                    <Radio checked={false} value={"D"} name={'question' + num} label={"D"} onChange={()=>{}}/>
                  </Block>
                </QuestionItem>
              )
            })
          }
        </QuestionsList>
      </Modal>
    )
  })

export default ACVModal;